// ============================================================
// remember-selection.ts  — セレクトの前回選択をブラウザ単位で記憶する
// ============================================================
//
// data-remember-selection="<キー>" を付けたセレクトは、選んだ値を
// localStorage に保存し、次回その画面を開いたときに復元する。
// 端末 (ブラウザ) 単位の記憶で、サーバー側の設定は変更しない。
// 画面側で既に値が入っている場合 (編集画面など) は上書きしない。

const PREFIX = 'nc.select.';

function read(key: string): string | null {
    try { return localStorage.getItem(key); } catch { return null; }
}

function write(key: string, value: string): void {
    try {
        if (value) localStorage.setItem(key, value);
        else localStorage.removeItem(key);
    } catch { /* プライベートブラウズ等では記憶しない */ }
}

function bind(select: HTMLSelectElement): void {
    const name = select.dataset.rememberSelection;
    if (!name) return;
    const key = PREFIX + name;

    if (!select.value) {
        const saved = read(key);
        if (saved && Array.from(select.options).some(option => option.value === saved)) {
            select.value = saved;
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    select.addEventListener('change', () => write(key, select.value));
}

document.addEventListener('DOMContentLoaded', () => {
    // 一覧選択ボタンやページ側の change 監視が出来上がってから復元する。
    setTimeout(() => {
        document.querySelectorAll<HTMLSelectElement>('select[data-remember-selection]').forEach(bind);
    }, 0);
});
